export default __webpack_public_path__ + "static/media/upload-file.81453d27.gif";